import React from 'react';
import { Row, Col, Button, Table, Skeleton, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import { Card, Container, Title, GoBack } from 'src/components';
import { table } from 'src/utils';
import { IReduxState } from 'src/store';
import {
  fetchColors,
  removeColor,
  updateColor,
} from 'src/store/colors/actions';

import EditableCell from './components/cell/cell.component';
import Pagination from './components/pagination/pagination.component';

import { IProps } from './colors.type';
import { columns } from './colors.utils';
import useColors from './colors.use';

const ColorsScreen: React.FC<IProps> = (props) => {
  useColors(props);

  const { colors } = props;

  const {
    loading,
    data,
    form,
    handleColors,
    editingKey,
    isEditing,
    handleEdit,
    handleSave,
    handleCancel,
    handleRemove,
  } = useColors(props);

  const navigate = useNavigate();

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  return (
    <Container type="fluid">
      <Row gutter={16} className="mt-2" align="middle" justify="space-between">
        <Col>
          <GoBack color="#444" />
          <Title
            foreword="Configurações"
            title="Cores"
            subtitle="Visualize abaixo a lista de cores cadastradas no sistema, clique no botão ao lado para adicionar mais."
          />
        </Col>
        <Col>
          <Button type="primary" onClick={() => navigate('/painel/cores/novo')}>
            Adicionar Nova
          </Button>
        </Col>
      </Row>
      {!loading ? (
        <Row gutter={16}>
          <Col span={24}>
            <Card>
              <Form form={form} component={false}>
                <Table
                  {...table}
                  bordered
                  components={components}
                  dataSource={data}
                  rowKey={(record: any) => record.id}
                  columns={columns({
                    editingKey,
                    isEditing,
                    handleEdit,
                    handleSave,
                    handleCancel,
                    handleRemove,
                  })}
                  rowClassName="editable-row"
                  pagination={false}
                />
              </Form>
            </Card>
          </Col>
          <Col span={24}>
            <Pagination pagesMeta={colors?.meta} handleSearch={handleColors} />
          </Col>
        </Row>
      ) : (
        <Row gutter={16}>
          <Col span={24}>
            <Card>
              <Skeleton active />
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  colors: state.colors.all,
});

export default connect(mapStateToProps, {
  fetchColors,
  removeColor,
  updateColor,
})(ColorsScreen);
